import { TOY_CHECKLIST_ITEM_TYPES } from '../../../../common/constants';

const TOY_CHECKLIST_ITEM_TYPE = TOY_CHECKLIST_ITEM_TYPES?.BOOLEAN?.value;

const toInteger = (value) => {
  const parsed = parseInt(value, 10);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const mapRequiredContentsToForm = (requiredContents) =>
  (requiredContents || [])?.map((content) => ({
    name: content?.name,
    description: content?.description,
    minimumQuantity: content?.minimumQuantity,
    maximumQuantity: content?.maximumQuantity,
    isArchived: content?.isArchived ?? false,
    imageKeys: content?.imageKeys || [],
    imageUrls: content?.imageUrls || [],
  }));

export const mapChecklistToForm = (checklist) =>
  (checklist || [])?.map((item) => ({
    text: item?.text,
    expected: typeof item?.expected === 'boolean' ? item?.expected : undefined,
    isBlocking: item?.isBlocking ?? false,
    isArchived: item?.isArchived ?? false,
  }));

export const buildRequiredContentsInput = (requiredContents) =>
  (requiredContents || [])
    ?.filter((content) => content?.name?.trim())
    ?.map((content) => ({
      name: content?.name?.trim(),
      description: content?.description?.trim() || undefined,
      minimumQuantity: toInteger(content?.minimumQuantity),
      maximumQuantity: toInteger(content?.maximumQuantity),
      isArchived: content?.isArchived ?? false,
      imageKeys: content?.imageKeys || [],
    }));

export const buildChecklistInput = (checklist) =>
  (checklist || [])
    ?.filter((item) => item?.text?.trim())
    ?.map((item) => ({
      text: item?.text?.trim(),
      type: TOY_CHECKLIST_ITEM_TYPE,
      expected: typeof item?.expected === 'boolean' ? item?.expected : undefined,
      isBlocking: item?.isBlocking ?? false,
      isArchived: item?.isArchived ?? false,
    }));
